import { Button } from '@CS/components/Button/Button';
import Popup from '@CS/components/Popups/Popup';
import { ErrorPopupContent, ErrorText } from './ErrorPopup.styles';

type ErrorPopupProps = {
  error: string;
  onClose?: () => void;
  onClick?: () => void;
};

export const ErrorPopup = ({ error, onClose, onClick }: ErrorPopupProps) => {
  return (
    <Popup onClose={onClose} hideClose={true} overlay={true} width={80}>
      <ErrorPopupContent>
        <ErrorText>{error}</ErrorText>
        <Button onClick={onClick}>OK</Button>
      </ErrorPopupContent>
    </Popup>
  );
};
